export enum OwnerDetailsTabEnum {
  BASIC = 'BASIC',
  CARDS = 'CARDS',
  PERSONAL = 'PERSONAL',
  SYSTEM = 'SYSTEM',
}
